import React from "react";
import {
  Grid, TextField, Paper, Button, IconButton, Box
} from "@material-ui/core";
import { Add, Delete, Save } from "@material-ui/icons";
import TextFieldCPF from "../../components/TextFieldCPF";
import TextFieldEmail from "../../components/base/TextFieldEmail";
import Swal from "sweetalert2";
import TextFieldTelefone from "../../components/base/TextFieldTelefone";



export default function FichaLocaisDeInstalacao(props) {
  const { data, setData } = props;
  const [insert, setInsert] =React.useState(false)

  const handleChange = (id, field, value) => {
    setData((prevData) =>
      prevData.map((row) => (row.id === id ? { ...row, [field]: value } : row))
    );
  };


  const handleAddRow = () => {

    setInsert(true)       

    const newId = data.length > 0 ? Math.max(...data.map((row) => row.id)) + 1 : 1;
    setData([...data, { id: newId, 
       nomeLocal : "",
        logradouro: "",
        numero: "",
        complemento: "",
        bairro: "",
        cep: "",
        cidade: "",
        estado: "",
        telefone: "",
        celular: "",
        contato: "",
        telefoneResponsavel :"",
        setor: "",
        emailResponsavel :"", }]);
  };

  const handleRemoveRow = (id) => {
    setInsert(false)
    setData(data.filter((row) => row.id !== id));
  };


  const handleInsertRow = (newData) => {
    // Verifica se já existe um local com o mesmo nome
    const exists = data.some(row => row.nomeLocal.trim().toLowerCase() === newData.nomeLocal.trim().toLowerCase());
  
    if (exists) {
      Swal.fire({
        title: "Duplicação Detectada",
        text: "Já existe um local com esse nome!",
        icon: "warning",
        confirmButtonText: "OK"
      });
      return;
    }
  
    // Se não existir, adiciona o novo local
    setData((prevData) => [
      ...prevData,
      {
        id: prevData.length > 0 ? Math.max(...prevData.map(row => row.id)) + 1 : 1,
        nomeLocal: newData.nomeLocal || "",
        logradouro: newData.logradouro || "",
        numero: newData.numero || "",
        complemento: newData.complemento || "",
        cep: newData.cep || "",
        bairro: newData.bairro || "",
        cidade: newData.cidade || "",
        estado: newData.estado || "",
        telefoneResponsavel: newData.telefone || "",
        celular: newData.celular || "",
        emailResponsavel: newData.email || "",
        contato: newData.nomeContato || "",
        setor  : newData.setor || "", 
      },
    ]);
  };
  
/*
  React.useEffect(()=>{

    if(props.localPadrao.nomeLocal){
        handleInsertRow(props.localPadrao);
    }

  }, [props.localPadrao])
*/
  return (
    <div style={{ width: '100%', marginTop: 20, padding: 10 }}>
      {data.map((row) => (
        <Paper key={row.id} style={{ padding: 20, marginBottom: 20, boxShadow: "0px 0px 15px rgba(185, 187, 211, 0.5)" }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                value={row.nomeLocal}
                onChange={(e) => handleChange(row.id, "nomeLocal", e.target.value)}
                label="Nome do Local"
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                value={row.logradouro}
                onChange={(e) => handleChange(row.id, "logradouro", e.target.value)}
                label="Logradouro"
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                value={row.numero}
                onChange={(e) => handleChange(row.id, "numero", e.target.value)}
                label="Número"
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                value={row.complemento}
                onChange={(e) => handleChange(row.id, "complemento", e.target.value)}
                label="Complemento"
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                value={row.cep}
                onChange={(e) => handleChange(row.id, "cep", e.target.value)}
                label="Cep"
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                value={row.bairro}
                onChange={(e) => handleChange(row.id, "bairro", e.target.value)}
                label="Bairro"
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>


            <Grid item xs={12} sm={6}>
              <TextField
                value={row.cidade}
                onChange={(e) => handleChange(row.id, "cidade", e.target.value)}
                label="Cidade"
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                value={row.estado}
                onChange={(e) => handleChange(row.id, "estado", e.target.value)}
                label="Estado"
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextFieldTelefone
                value={row.telefoneResponsavel}
                onChange={(e) => handleChange(row.id, "telefoneResponsavel", e.target.value)}
                label="Telefone"
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextFieldTelefone
                value={row.celular}
                onChange={(e) => handleChange(row.id, "celular", e.target.value)}
                label="Celular"
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextFieldEmail
                value={row.emailResponsavel}
                onChange={(e) => handleChange(row.id, "emailResponsavel", e.target.value)}
                label="Email NFe"
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                value={row.contato}
                onChange={(e) => handleChange(row.id, "contato", e.target.value)}
                label="Nome do Contato"
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>


            <Grid item xs={12} sm={12} container justifyContent="center" alignItems="center" style={{display: 'flex', justifyContent : 'center'}}>
                <Button variant="contained" size='large' disabled={!insert} onClick={() =>{
                    Swal.fire({
                          title : 'Confirmação de Registro', 
                          text : 'Confirma a inclusão do registro?', 
                          icon : 'question', 
                          showCancelButton : true, 
                          cancelButtonText : 'Não', 
                          showConfirmButton : true, 
                          confirmButtonText : 'Sim',
                      }).then(resposta=>{      
                          if(resposta.isConfirmed){      
                            setInsert(false)                              
                          }      
                      })
                } } color="primary">
                    <Save /><span style={{paddingLeft : '5px'}}>Gravar</span>
                </Button>
                <Button style={{marginLeft : '5px'}} variant="contained" size='large' color='secondary' onClick={() =>{
                    Swal.fire({
                          title : 'Exclusão de Registro', 
                          text : 'Confirma a exclusão do registro?', 
                          icon : 'question', 
                          showCancelButton : true, 
                          cancelButtonText : 'Não', 
                          showConfirmButton : true, 
                          confirmButtonText : 'Sim',
                          
                      }).then(resposta=>{      
                          if(resposta.isConfirmed){      
                              handleRemoveRow(row.id)                              
                          }      
                      })
                } }>
                    <Delete /> <span style={{paddingLeft : '5px'}}>Excluir</span>
                </Button>
            </Grid>

          </Grid>
        </Paper>
      ))}
      <Box display="flex" justifyContent="center" padding={2}>
        {!insert ? <Button
          onClick={handleAddRow}
          variant="contained"
          color="primary"
          startIcon={<Add />}
        >
          NOVO LOCAL DE INSTALAÇÃO
        </Button> : null }
      </Box>
    </div>
  );
}
